/** @format */

import * as FileSaver from "file-saver";
import ExcelJS from "exceljs";
import { formatCurr } from "utils/helper";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

type ExportAlokasiType = {
  auth: any;
  provinsi: any;
  kabkota: any;
  dataMadrasah: any;
};

export const handleExportExcelAlokasi = async ({
  auth,
  provinsi,
  kabkota,
  dataMadrasah,
}: ExportAlokasiType) => {
  var ExcelJSWorkbook = new ExcelJS.Workbook();
  var worksheet = ExcelJSWorkbook.addWorksheet("Data");
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  worksheet.mergeCells("A1:S1");

  worksheet.getColumn("A").width = 5;
  worksheet.getColumn("B").width = 14;
  worksheet.getColumn("C").width = 40;
  worksheet.getColumn("D").width = 10;
  worksheet.getColumn("E").width = 30;
  worksheet.getColumn("F").width = 30;
  worksheet.getColumn("G").width = 30;
  worksheet.getColumn("H").width = 30;
  worksheet.getColumn("I").width = 30;
  worksheet.getColumn("J").width = 30;
  worksheet.getColumn("K").width = 30;
  worksheet.getColumn("L").width = 30;
  worksheet.getColumn("M").width = 30;
  worksheet.getColumn("N").width = 30;
  worksheet.getColumn("O").width = 35;
  worksheet.getColumn("P").width = 20;
  worksheet.getColumn("Q").width = 25;
  worksheet.getColumn("R").width = 20;
  worksheet.getColumn("S").width = 40;

  const headerCell = worksheet.getCell("A1");
  headerCell.font = {
    size: 11,
    underline: true,
    bold: true,
  };
  headerCell.alignment = { vertical: "middle", horizontal: "center" };
  headerCell.value = `ALOKASI SUMBER DANA BOS T.A ${auth.isTahun}`;

  let dataTmp: any = [];
  dataMadrasah.map((e, i) => {
    return dataTmp.push([
      i + 1,
      e.nsm,
      e.namaMadrasah,
      e.jenjang,
      provinsi.find((item) => item.kode === e.kodeProvinsi).nama || "",
      kabkota.find((item) => item.kode === e.kodeKabKota).nama || "",
      formatCurr(e.apbn_bos_semester1),
      formatCurr(e.apbn_bos_semester2),
      formatCurr(e.apbn_bos_triwulan1),
      formatCurr(e.apbn_bos_triwulan2),
      formatCurr(e.apbn_bos_triwulan3),
      formatCurr(e.apbn_bos_triwulan4),
      formatCurr(e.apbn_bos_semester2 - e.nilaiAa),
      formatCurr(e.nilaiAa),
      formatCurr(
        e.apbn_bos_semester1 +
          e.apbn_bos_semester2 +
          e.apbn_bos_triwulan1 +
          e.apbn_bos_triwulan2 +
          e.apbn_bos_triwulan3 +
          e.apbn_bos_triwulan4,
      ),
      e.jumlahSiswa,
      e.namaBank,
      e.nomorRekening,
      e.namaPemilikRekening,
    ]);
  });

  worksheet.addTable({
    name: "Table",
    ref: "A3",
    headerRow: true,
    style: {
      showRowStripes: true,
    },
    columns: [
      { name: "No" },
      { name: "NSM" },
      { name: "Madrasah" },
      { name: "Jenjang" },
      { name: "Provinsi" },
      { name: "Kabupaten" },
      { name: "Semester I" },
      { name: "Semester II" },
      { name: "Triwulan I" },
      { name: "Triwulan II" },
      { name: "Triwulan III" },
      { name: "Triwulan IV" },
      { name: "Non AA" },
      { name: "AA" },
      { name: "Total" },
      { name: "Jumlah Siswa" },
      { name: "Bank" },
      { name: "No Rekening" },
      { name: "Nama Pemilik Rekening" },
    ],
    rows: dataTmp,
  });

  const excelBuffer = await ExcelJSWorkbook.xlsx.writeBuffer();
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, `Alokasi-Sumber-Dana-BOS${fileExtension}`);
};

export const handleExportPdfAlokasi = ({
  auth,
  provinsi,
  kabkota,
  dataMadrasah,
}: ExportAlokasiType) => {
  const doc: any = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
    floatPrecision: 16,
  });

  doc.setFont("times", "bold");
  doc.text(`ALOKASI SUMBER DANA BOS T.A ${auth.isTahun}`, 150, 10, {
    align: "center",
  });

  var headers: any = [
    { id: "id", dataKey: "id", padding: 0, header: "No", width: 22 },
    {
      id: "nsm",
      dataKey: "nsm",
      padding: 0,
      header: "NSM",
      width: 50,
    },
    {
      id: "nama",
      dataKey: "nama",
      padding: 0,
      header: "Madrasah",
      width: 50,
    },
    {
      id: "jenjang",
      dataKey: "jenjang",
      padding: 0,
      header: "Jenjang",
      width: 40,
    },
    {
      id: "jumlahSiswa",
      dataKey: "jumlahSiswa",
      padding: 0,
      header: "Jumlah Siswa",
      width: 30,
    },
    {
      id: "provinsi",
      dataKey: "provinsi",
      padding: 0,
      header: "Provinsi",
      width: 50,
    },
    {
      id: "kabkota",
      dataKey: "kabkota",
      padding: 0,
      header: "Kab / Kota",
      width: 50,
    },
    {
      id: "tahapanI",
      dataKey: "tahapanI",
      padding: 0,
      header: "Tahapan I",
      width: 50,
    },
    {
      id: "tahapanII",
      dataKey: "tahapanII",
      padding: 0,
      header: "Tahapan II",
      width: 50,
    },
    {
      id: "nonAA",
      dataKey: "nonAA",
      padding: 0,
      header: "Non AA",
      width: 50,
    },
    {
      id: "aa",
      dataKey: "aa",
      padding: 0,
      header: "AA",
      width: 50,
    },
    {
      id: "total",
      dataKey: "total",
      padding: 0,
      header: "Total",
      width: 50,
    },
    {
      id: "bank",
      dataKey: "bank",
      padding: 0,
      header: "Bank",
      width: 39,
    },
    {
      id: "noRekening",
      dataKey: "noRekening",
      padding: 0,
      header: "No Rekening",
      width: 39,
    },
    {
      id: "namaPemilikRekening",
      dataKey: "namaPemilikRekening",
      padding: 0,
      header: "Nama Pemilik Rekening",
      width: 39,
    },
  ];
  let las: any = [];
  // const count = type === "pdf_all" ? tableData.length : 10;
  autoTable(doc, {
    styles: { lineColor: 244, lineWidth: 0.1, fontSize: 6 },
    headStyles: {
      halign: "center",
      valign: "middle",
      fillColor: [0, 128, 0],
    }, // Cells in first column centered and green
    columnStyles: {
      0: { halign: "center", cellWidth: 8 },
      1: { halign: "center", cellWidth: 22 },
      2: { halign: "left", cellWidth: 38 },
      3: { halign: "center", cellWidth: 13 },
      4: { halign: "center", cellWidth: 12 },
      5: { halign: "left", cellWidth: 20 },
      6: { halign: "left", cellWidth: 20 },
      7: { halign: "right", cellWidth: 17 },
      8: { halign: "right", cellWidth: 17 },
      9: { halign: "right", cellWidth: 17 },
      10: { halign: "right", cellWidth: 17 },
      11: { halign: "right", cellWidth: 17 },
      12: { halign: "left", cellWidth: 24 },
      13: { halign: "left", cellWidth: 25 },
      14: { halign: "left", cellWidth: 24 },
    },
    startY: 15,
    margin: { top: 3, left: 3, right: 3 },
    columns: headers,
    body: dataMadrasah.map((e, i) => {
      return {
        id: i + 1,
        nsm: e.nsm,
        nama: e.namaMadrasah,
        jenjang: e.jenjang,
        jumlahSiswa: e.jumlahSiswa,
        provinsi:
          provinsi.find((item) => item.kode === e.kodeProvinsi)?.nama || "",
        kabkota:
          kabkota.find((item) => item.kode === e.kodeKabKota)?.nama || "",
        tahapanI: formatCurr(e.apbn_bos_semester1),
        tahapanII: formatCurr(e.apbn_bos_semester2),
        nonAA: formatCurr(e.apbn_bos_semester2 - e.nilaiAa),
        aa: formatCurr(e.nilaiAa),
        total: formatCurr(e.apbn_bos_semester1 + e.apbn_bos_semester2),
        bank: e.namaBank,
        noRekening: e.nomorRekening,
        namaPemilikRekening: e.namaPemilikRekening,
      };
    }),
    didDrawPage: (d) => las.push(d.cursor),
  });
  var blob = doc.output("blob", { filename: "alokasi-sumber-dana-bos" });
  window.open(URL.createObjectURL(blob));
};
